'use client';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useEffect, forwardRef, useRef } from 'react';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { CriticalIcon, CheckmarkBackgroundIcon } from '@paypalcorp/pp-react-icons';
import { cx } from '@paypalcorp/pp-react-utils';
import * as styles from './styles.css';
export { styles as textInputStyles };
import { screenReaderStyles } from '@paypalcorp/pp-react-screen-reader';

var _excluded$3 = ["setFocus", "className", "inputClassName", "labelClassName", "successText", "successIconAriaLabel", "errorText", "error", "errorIconAriaLabel", "helperText", "value", "name", "id", "label", "isLabelHidden", "placeholder", "placemat", "leftIcon", "rightIcon", "onChange", "children", "renderContent", "removeBorderRadiusLeft", "removeBorderRadiusRight", "removeBorderRadiusBoth", "dir"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FormMessage = function (_ref) {
  var messageId = _ref.messageId,
    helperText = _ref.helperText,
    errorText = _ref.errorText,
    errorIconAriaLabel = _ref.errorIconAriaLabel,
    successText = _ref.successText,
    successIconAriaLabel = _ref.successIconAriaLabel;
  // errorText takes higher priority over helperText
  if (errorText || successText) {
    var _errorIcon;
    var text = errorText ? errorText : successText;
    var processText = Array.isArray(text) ? /*#__PURE__*/React.createElement("ul", {
      className: styles.multiLineError,
      "data-ppui": "true"
    }, text.map(function (msg, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "msg".concat(messageId, "-").concat(index),
        "data-ppui": "true"
      }, msg);
    })) : text;
    var errorIcon, successIcon;
    if (errorText) {
      var errorProps = {
        className: styles.errorIcon,
        role: 'img',
        'aria-label': errorIconAriaLabel
      };
      errorIcon = /*#__PURE__*/React.createElement(CriticalIcon, _extends({
        size: "sm"
      }, errorProps, {
        "data-ppui": "true"
      }));
    }
    if (!errorText) {
      var successProps = {
        className: styles.successIcon,
        role: 'img',
        'aria-label': successIconAriaLabel
      };
      successIcon = /*#__PURE__*/React.createElement(CheckmarkBackgroundIcon, _extends({
        size: "sm"
      }, successProps, {
        "data-ppui": "true"
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles.errorText,
      id: messageId,
      role: "alert",
      "data-ppui": "true"
    }, (_errorIcon = errorIcon) !== null && _errorIcon !== void 0 ? _errorIcon : successIcon, processText);
  }
  if (helperText) {
    var _processText = Array.isArray(helperText) ? /*#__PURE__*/React.createElement("ul", {
      className: styles.helperText,
      id: messageId,
      "data-ppui": "true"
    }, helperText.map(function (msg, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "msg".concat(messageId, "-").concat(index),
        "data-ppui": "true"
      }, msg);
    })) : /*#__PURE__*/React.createElement("div", {
      className: styles.helperText,
      id: messageId,
      "data-ppui": "true"
    }, helperText);
    return _processText;
  }
  return null;
};
var renderIcon = function (icon, side, className) {
  return icon ? /*#__PURE__*/React.createElement("div", {
    className: cx(side === 'left' && styles.iconLeft, side === 'right' && styles.iconRight, className),
    key: "icon-".concat(side),
    "data-ppui": "true"
  }, icon) : null;
};
var TextInputWrapper = function (_ref2) {
  var setFocus = _ref2.setFocus,
    className = _ref2.className,
    inputClassName = _ref2.inputClassName,
    labelClassName = _ref2.labelClassName,
    successText = _ref2.successText,
    _ref2$successIconAria = _ref2.successIconAriaLabel,
    successIconAriaLabel = _ref2$successIconAria === void 0 ? 'Success' : _ref2$successIconAria,
    errorText = _ref2.errorText,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? !!errorText : _ref2$error,
    _ref2$errorIconAriaLa = _ref2.errorIconAriaLabel,
    errorIconAriaLabel = _ref2$errorIconAriaLa === void 0 ? 'Error' : _ref2$errorIconAriaLa,
    helperText = _ref2.helperText,
    value = _ref2.value,
    name = _ref2.name,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? "text-input-".concat(name) : _ref2$id,
    label = _ref2.label,
    isLabelHidden = _ref2.isLabelHidden,
    _ref2$placeholder = _ref2.placeholder,
    placeholder = _ref2$placeholder === void 0 ? ' ' : _ref2$placeholder,
    placemat = _ref2.placemat,
    _ref2$leftIcon = _ref2.leftIcon,
    leftIcon = _ref2$leftIcon === void 0 ? null : _ref2$leftIcon,
    _ref2$rightIcon = _ref2.rightIcon,
    rightIcon = _ref2$rightIcon === void 0 ? null : _ref2$rightIcon,
    onChange = _ref2.onChange;
    _ref2.children;
    var renderContent = _ref2.renderContent;
    _ref2.removeBorderRadiusLeft;
    _ref2.removeBorderRadiusRight;
    _ref2.removeBorderRadiusBoth;
    var dir = _ref2.dir,
    rest = _objectWithoutProperties(_ref2, _excluded$3);
  var msgId = "message_".concat(id);
  var valueProps = onChange ? {
    onChange: onChange,
    value: value
  } : {
    defaultValue: value
  };
  var ariaDescribedByProp = helperText || errorText ? {
    'aria-describedby': msgId
  } : {};
  var otherProps = _objectSpread(_objectSpread(_objectSpread({}, ariaDescribedByProp), valueProps), rest);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.base, className),
    dir: dir,
    "data-ppui-info": "text-input_6.2.3__8.12.2-beta.0"
  }, renderIcon(leftIcon, 'left'), renderContent(_objectSpread({
    inputClassName: inputClassName,
    name: name,
    id: id,
    setFocus: setFocus,
    hasError: error,
    placeholder: placeholder,
    placemat: placemat,
    label: label,
    labelClassName: labelClassName,
    isLabelHidden: isLabelHidden,
    inputTag: 'input',
    leftIcon: leftIcon,
    rightIcon: rightIcon
  }, otherProps)), /*#__PURE__*/React.createElement(FormMessage, {
    errorText: errorText,
    errorIconAriaLabel: errorIconAriaLabel,
    successText: successText,
    successIconAriaLabel: successIconAriaLabel,
    helperText: helperText,
    messageId: msgId,
    "data-ppui": "true"
  }), renderIcon(rightIcon, 'right'));
};

var _excluded$2 = ["inputClassName", "inputTag", "name", "id", "setFocus", "inputRef", "hasError", "placeholder", "placemat", "label", "labelClassName", "isLabelHidden", "rightIcon", "leftIcon", "prefix", "suffix"];
var overlayValue = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var mask = arguments.length > 1 ? arguments[1] : undefined;
  var vLen = value.length;
  var mLen = mask.length;
  if (vLen >= mLen) {
    return value;
  }
  return value.concat(mask.substring(vLen));
};
var Placemat = function (_ref) {
  var placeholder = _ref.placeholder,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$isLabelHidden = _ref.isLabelHidden,
    isLabelHidden = _ref$isLabelHidden === void 0 ? false : _ref$isLabelHidden;
  var combinedText = overlayValue(value, placeholder);
  var classes = cx(styles.placemat, isLabelHidden && styles.noLabelPlacemat);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    "data-ppui": "true"
  }, combinedText);
};
var normalizePlaceholder = function (placeholder) {
  var normalized = placeholder !== null && placeholder !== void 0 ? placeholder : ' ';
  return normalized === '' ? ' ' : normalized;
};

// eslint-disable-next-line complexity
var TextInputContent = function (_ref2) {
  var inputClassName = _ref2.inputClassName,
    inputTag = _ref2.inputTag,
    name = _ref2.name,
    id = _ref2.id,
    setFocus = _ref2.setFocus,
    inputRef = _ref2.inputRef,
    hasError = _ref2.hasError,
    placeholder = _ref2.placeholder,
    placemat = _ref2.placemat,
    label = _ref2.label,
    labelClassName = _ref2.labelClassName,
    isLabelHidden = _ref2.isLabelHidden,
    rightIcon = _ref2.rightIcon,
    leftIcon = _ref2.leftIcon,
    prefix = _ref2.prefix,
    suffix = _ref2.suffix,
    rest = _objectWithoutProperties(_ref2, _excluded$2);
  var isLabelHiddenFinal = !label || label === '' || isLabelHidden;
  // DO NOT CHANGE THE ORDER OF THE STYLES BELOW
  var inputTagClasses = cx(styles.control, isLabelHiddenFinal && styles.nolabelControl, !hasError && rightIcon && styles.controlWithIconRight, !hasError && leftIcon && styles.controlWithIconLeft, !hasError && rightIcon && leftIcon && styles.controlWithIconLeftAndRight, styles.labelWhenPlaceholderShownAndInputNotFocused, hasError && styles.errorControl, hasError && isLabelHiddenFinal && styles.noLabelControlError, hasError && rightIcon && styles.controlErrorWithIconRight, hasError && leftIcon && styles.controlErrorWithIconLeft, hasError && leftIcon && rightIcon && styles.controlErrorWithIconLeftAndRight, prefix || suffix ? styles.prefixWrapperControl : null, hasError && isLabelHiddenFinal && (prefix || suffix) ? styles.noLabelControlError : null, prefix && styles.prefixWrapperControlWithPrefix, suffix && styles.prefixWrapperControlWithSuffix, prefix && suffix && styles.prefixWrapperControlWithPrefixSuffix, inputClassName);
  var labelClasses = cx(styles.label, rightIcon && styles.labelWithIconRight, leftIcon && styles.labelWithIconLeft, isLabelHiddenFinal && screenReaderStyles.screenReader, labelClassName);
  // @ts-ignore
  var value = rest.value;
  useEffect(function () {
    var elem = inputRef.current;
    if (setFocus && elem) {
      elem.focus();
    }
  }, [setFocus]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!placemat && /*#__PURE__*/React.createElement(Placemat, {
    placeholder: placemat,
    value: value,
    isLabelHidden: isLabelHiddenFinal,
    "data-ppui": "true"
  }), /*#__PURE__*/React.createElement(inputTag, _extends({
    className: inputTagClasses,
    name: name,
    id: id,
    ref: inputRef,
    "aria-invalid": hasError,
    placeholder: normalizePlaceholder(placeholder)
  }, rest, {
    "data-ppui": "true"
  })), label && /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    id: "".concat(id, "-label"),
    className: labelClasses,
    "data-ppui": "true"
  }, label));
};

var _excluded$1 = ["label", "id", "prefix", "suffix", "prefixClassName", "suffixClassName", "inputClassName", "inputRef", "onBlur", "onFocus", "hasError", "isLabelHidden"];
var TextInputContentWithPrefixSuffix = function (_ref) {
  var label = _ref.label,
    id = _ref.id,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    prefixClassName = _ref.prefixClassName,
    suffixClassName = _ref.suffixClassName,
    inputClassName = _ref.inputClassName,
    inputRef = _ref.inputRef,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
    hasError = _ref.hasError,
    isLabelHidden = _ref.isLabelHidden,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  var textInputRef = inputRef;
  var isLabelHiddenFinal = !label || label === '' || isLabelHidden;
  var prefixClass = cx(styles.prefix, isLabelHiddenFinal && styles.noLabelSuffixOrPrefix, hasError && styles.errorStatePrefix, prefixClassName);
  var suffixClass = cx(styles.suffix, isLabelHiddenFinal && styles.noLabelSuffixOrPrefix, hasError && styles.errorStateSuffix, suffixClassName);
  var prefixWrapperClass = cx(styles.prefixWrapper, hasError && styles.prefixWrapperError);
  var labelId = label ? "".concat(id, "-label ") : '';
  var prefixEleId = prefix ? "".concat(id, "-prefix ") : '';
  var suffixEleId = suffix ? "".concat(id, "-suffix") : '';
  var ariaLabelledByIds = "".concat(labelId).concat(prefixEleId).concat(suffixEleId);
  return /*#__PURE__*/React.createElement("div", {
    className: prefixWrapperClass,
    onClick: function handlePrefixWrapperClick() {
      /* istanbul ignore else */
      if (textInputRef.current) {
        var textInputElm = textInputRef.current;
        textInputElm.focus();
      }
    },
    "data-ppui": "true"
  }, /*#__PURE__*/React.createElement(TextInputContent, _extends({
    label: label,
    id: id,
    prefix: prefix,
    suffix: suffix,
    inputClassName: inputClassName,
    inputRef: inputRef,
    onFocus: function handleFocus(event) {
      /* istanbul ignore else */
      if (onFocus) {
        onFocus(event);
      }
    },
    onBlur: function handleBlur(event) {
      /* istanbul ignore else */
      if (onBlur) {
        onBlur(event);
      }
    },
    "aria-labelledby": ariaLabelledByIds.trim(),
    hasError: hasError,
    isLabelHidden: isLabelHiddenFinal
  }, rest, {
    "data-ppui": "true"
  })), prefix && /*#__PURE__*/React.createElement("div", {
    id: prefixEleId.trim(),
    className: prefixClass,
    "data-ppui": "true"
  }, prefix), suffix && /*#__PURE__*/React.createElement("div", {
    id: suffixEleId.trim(),
    className: suffixClass,
    "data-ppui": "true"
  }, suffix));
};

var _excluded = ["prefix", "suffix", "prefixClassName", "suffixClassName"],
  _excluded2 = ["inputClassName", "name", "id", "setFocus", "hasError", "placeholder", "placemat", "label", "labelClassName", "inputTag"];
var TextInput = forwardRef(function (_ref, ref) {
  var prefix = _ref.prefix,
    suffix = _ref.suffix,
    prefixClassName = _ref.prefixClassName,
    suffixClassName = _ref.suffixClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var internalRef = useRef();
  var textInputRef = ref || internalRef;
  return /*#__PURE__*/React.createElement(TextInputWrapper, _extends({
    renderContent: function renderContent(_ref2) {
      var inputClassName = _ref2.inputClassName,
        name = _ref2.name,
        id = _ref2.id,
        setFocus = _ref2.setFocus,
        hasError = _ref2.hasError,
        placeholder = _ref2.placeholder,
        placemat = _ref2.placemat,
        label = _ref2.label,
        labelClassName = _ref2.labelClassName,
        inputTag = _ref2.inputTag,
        otherProps = _objectWithoutProperties(_ref2, _excluded2);
      if (prefix || suffix) {
        return /*#__PURE__*/React.createElement(TextInputContentWithPrefixSuffix, _extends({
          inputClassName: inputClassName,
          inputTag: inputTag,
          name: name,
          id: id,
          setFocus: setFocus,
          inputRef: textInputRef,
          hasError: hasError,
          placeholder: placeholder
          /*placemat={placemat}  placemat is currently not supported with prefix and suffix*/,
          label: label,
          labelClassName: labelClassName,
          prefix: prefix,
          suffix: suffix,
          prefixClassName: prefixClassName,
          suffixClassName: suffixClassName
        }, otherProps, {
          "data-ppui": "true"
        }));
      }
      return /*#__PURE__*/React.createElement(TextInputContent, _extends({
        inputClassName: inputClassName,
        inputTag: inputTag,
        name: name,
        id: id,
        setFocus: setFocus,
        inputRef: textInputRef,
        hasError: hasError,
        placeholder: placeholder,
        placemat: placemat,
        label: label,
        labelClassName: labelClassName
      }, otherProps, {
        "data-ppui": "true"
      }));
    }
  }, props, {
    "data-ppui": "true"
  }));
});

export { TextInput, TextInputContent, TextInputWrapper };
